import React from 'react';
import styled from 'styled-components';
import { Rating } from '@tvg/fuse-design';
import analyticsEvent from 'services/analytic/analytic-service';
import scrollElementIntoView from '@sd-utility/scrollelementintoview';

const Container = styled.div`
  margin-bottom: var(--spacing-space24);
  cursor: pointer;
  display: flex;
  order: 2;
`;

type Props = {
  reviewTotal: number;
  reviewStars: number;
};

function StarRating(props: Props) {
  const { reviewTotal, reviewStars } = props;

  const sendAnalyticsEvent = (element: string) => {
    analyticsEvent({
      gaCategory: 'Bazaarvoice RatingsAndReviews',
      gaAction: `Bazaarvoice : RatingsAndReviews : Review ${element} Click`,
      gaLabel: 'Product',
    });
  };

  const handleClick = (event: any, element: string) => {
    event.preventDefault();
    scrollElementIntoView(document.getElementById('ratings-and-reviews'));
    sendAnalyticsEvent(element);
  };

  return (
    <Container data-testid="rating-and-reviews-summary">
      <Rating
        dataTestId="rating-and-reviews-summary_rating"
        onClick={(event: MouseEvent) => handleClick(event, 'Star and Text')}
        rating={reviewStars}
        reviewLinkText={`${reviewTotal} reviews`}
        reviewLink="#"
      />
    </Container>
  );
}

export default StarRating;
